import styled from 'styled-components';
import C from '@assets/themes/colors';

export const Root = styled.div`
    display:flex;
    gap:3px;
`;

export const Line = styled.div`
    border-left: 1px solid rgba(204, 204, 204, 0.3);;
    height: 21px;
    margin-top: 12px;
`;

export const BackContainer = styled.div`
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${C.WHITE};
  display: flex;
  align-items: center;
  cursor: pointer;
`

export const Label = styled.label`
  margin-top: 15px;
  margin-bottom: 16px;
  font-family: Roboto;
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: ${C.WHITE};
  display: flex;
`;